"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Credentials = __importStar(require("../credentials"));
const Store = __importStar(require("../store"));
const conf_1 = require("../conf");
exports.default = (App, permission) => (props) => {
    const permissions = Credentials.getPermissions();
    const path = props.location.pathname;
    if (!permissions) {
        Store.set(conf_1.REDIRECT_URI, path);
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/' });
    }
    if (permission && !permissions.includes(permission)) {
        Store.set(conf_1.REDIRECT_URI, path);
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/unauthorized' });
    }
    const redirectUri = Store.get(conf_1.REDIRECT_URI);
    if (redirectUri) {
        Store.remove(conf_1.REDIRECT_URI);
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirectUri });
    }
    return react_1.default.createElement(App, Object.assign({}, props));
};
